import React, { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";

// Components
import Hero from "./components/Hero";
import MarqueeStrip from "./components/Marquee";
import Concept from "./components/Concept";
import Menu from "./components/Menu";
import Experience from "./components/Experience";
import Expansion from "./components/Expansion";
import Reviews from "./components/Reviews";
import FinalCTA from "./components/FinalCTA";
import Burger from "./components/Burger";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App overflow-x-hidden" data-testid="santomato-app">
      {/* Hero Section */}
      <Hero />
      
      {/* Marquee Strip */}
      <MarqueeStrip texts={["FRESH", "HOT", "TASTY", "GRANDE", "CROCCANTE", "DAL 1985"]} />
      
      {/* Concept Section */}
      <Concept />
      
      {/* Marquee Strip */}
      <MarqueeStrip 
        texts={["PIZZA LOVERS", "BIBITE FREE REFILL", "PREZZI GIUSTI", "AMICI & FAMIGLIA"]} 
        bgColor="bg-santomato-yellow"
      />
      
      {/* Menu Section */}
      <Menu />
      
      {/* Marquee Strip */}
      <MarqueeStrip 
        texts={["SMASH BURGER", "DOPPIO SMASH DI MANZO", "CHEDDAR FONDENTE", "VERSIONE SPICY"]} 
        bgColor="bg-black"
      />
      
      {/* Smash Burger Section */}
      <Burger />
      
      {/* Experience Section */}
      <Experience />
      
      {/* Marquee Strip */}
      <MarqueeStrip texts={["NUOVE APERTURE", "VIENI A TROVARCI", "TI ASPETTIAMO"]} />
      
      {/* Expansion Section */}
      <Expansion />
      
      {/* Reviews Section */}
      <Reviews />
      
      {/* Final CTA */}
      <FinalCTA />
      
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
